<template>
  <div class="page landing">
    <section class="content">
      <div class="button" @click="handleDownload">立即提现</div>
    </section>
    <download-cover v-if="isShowMask" />
    <ios-download v-model="downloadVisible"></ios-download>
    <ios-wxmp-dialog v-model="iosWxmpQRCodeDialogVisible"></ios-wxmp-dialog>
    <ios-wxmp-link-dialog v-model="iosWxmpLinkDialogVisible"></ios-wxmp-link-dialog>
    <web-clip-pop v-model="webclipPopVisible" @onClose="webclipPopVisible=false"/>
    <web-clip-copy-pop v-model="copyPopVisible" @onClose="copyPopVisible=false"/>
  </div>
</template>

<script>
import { Swipe, SwipeItem } from 'vant'
import { judgeClientSystem, isWxMiniprogram, isBaiduMiniprogram } from '@/assets/utils'
import DownloadCover from '@/components/download-cover'
import IosDownload from '@/components/ios-download'
import IosWxmpDialog from '@/components/ios-wxmp-qrcode-dialog'
import IosWxmpLinkDialog from '@/components/ios-wxmp-link-dialog'
import isIntercept from '@/assets/intercept-mixin'
import WebClipPop from '../components/web-clip-pop.vue'
import WebClipCopyPop from '../components/web-clip-copy-pop.vue'

export default {
  name: 'landingGeneralResult',
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    DownloadCover,
    IosDownload,
    WebClipPop,
    WebClipCopyPop,
    IosWxmpDialog,
    IosWxmpLinkDialog
  },
  data () {
    return {
      home: this.$route.query.home, // 是否直接跳转首页，值为T
      auto: this.$route.query.auto, // 是否自动下载，值为T
      isIos: judgeClientSystem() === 'IOS',
      downloadVisible: false,
      iosWxmpQRCodeDialogVisible: false,
      iosWxmpLinkDialogVisible: false,
      channel: '',
      webclipPopVisible: false,
      copyPopVisible: false
    }
  },
  async created () {
    this.$bus.$emit('ready')
    this.channel = this.$route.query.channel || this.$storage.get('channel') || 'official'
    await isIntercept(this.channel)

    if (window && window.my && window.my.getEnv) {
      window.my.getEnv(function (res) {
        if (res.miniprogram) { // 当前是小程序环境，postMessage到webview执行跳转
          window.my.postMessage({
            actionType: 3,
            url: location.href
          })
        }
      })
    }
    if (this.auto === 'T' && !this.isShowMask) {
      this.downloadApp()
    }
  },
  computed: {
    downloadButtonTitle () {
      if (isWxMiniprogram() || isBaiduMiniprogram()) {
        return '点击复制链接到浏览器打开'
      }
      return `下载${this.isIos ? this.packageKey : '天美贷'}立即提现`
    }
  },
  methods: {
    // 下载事件
    handleDownload () {
      this.$report({
        id: 50019,
        args: {
          target: 'GENERAL_RESULT2'
        }
      })
      this.downloadApp()
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

@keyframes rotate {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
  }
}
.landing {
  height: 1624px;
  background: url(https://static.ndmicro.com/tmd/landing/general2/images/img_zhichayibu@2x.png) top center no-repeat #84B5FC;
  background-size: 100%;
  padding-top: 1px;
  .content{
    .button{
      width: 520px;
      height: 100px;
      line-height: 100px;
      background: url(https://static.ndmicro.com/tmd/landing/general2/images/btn_jiekuan@2x.png) center no-repeat;
      background-size: 100%;
      text-align: center;
      font-size: 36px;
      color: #FFFFFF;
      border-radius: 60px;
      box-shadow: 0px 7px 20px 0px rgba(226, 48, 48, 0.15);
      margin: 713px auto 0;
      font-weight: bold;
      animation: rotate 1s linear infinite;
    }
    .my-swipe{
      width: 670px;
      height: 60px;
      line-height: 60px;
      background-color: rgba(108, 71, 33, .5);
      border-radius: 10px;
      margin: 30px auto 0;
      font-size: 22px;
      color: #fff;
      padding: 0 20px;
    }
  }
}
</style>